import img1 from '../../src/assets/partner/brand-1.png';
import img2 from '../../src/assets/partner/brand-2.png';
import img3 from '../../src/assets/partner/brand-3.png';
import img4 from '../../src/assets/partner/brand-4.png';
import img5 from '../../src/assets/partner/brand-5.jpg';
import img6 from '../../src/assets/partner/brand-6.png';
import img7 from '../../src/assets/partner/brand-7.png';
import img8 from '../../src/assets/partner/brand-8.png';
import img9 from '../../src/assets/partner/brand-9.png';   // HTW
import img11 from '../../src/assets/partner/brand-11.png'; // INTRAVIS

const partnerData = [
  {
    id: 1,
    title: "Injection Molding Machine",
    slug: "injection-molding",
    shortDescription: "High-performance injection molding machines for precision manufacturing.",
    description: "Our advanced injection molding machines are designed for optimal performance and precision in plastic manufacturing. These machines feature state-of-the-art technology for efficient operation and consistent quality output.",
    image: img1,
    isFeatured: true,
    displayOrder: 1
  },
  {
    id: 2,
    title: "Beverage Filling Line",
    slug: "beverage-filling",
    shortDescription: "Complete beverage filling systems for efficient bottling operations.",
    description: "Our beverage filling lines provide end-to-end solutions for bottling operations. These systems are designed for high-speed production with precision filling capabilities for various types of beverages and container formats.",
    image: img2,
    isFeatured: true,
    displayOrder: 2
  },
  {
    id: 3,
    title: "PET Preform Molds",
    slug: "pet-preform",
    shortDescription: "Precision-engineered molds for PET preform production.",
    description: "Our PET preform molds are precision-engineered to produce high-quality preforms with consistent wall thickness and weight distribution. These molds are designed for durability and long production runs while maintaining tight tolerances.",
    image: img3,
    isFeatured: true,
    displayOrder: 3
  },
  {
    id: 4,
    title: "Lab Equipment",
    slug: "lab-equipment",
    shortDescription: "Specialized laboratory equipment for material testing and quality control.",
    description: "Our laboratory equipment provides comprehensive testing capabilities for plastic materials and finished products. These systems enable rigorous quality control processes and material validation to ensure compliance with industry standards.",
    image: img4,
    isFeatured: true,
    displayOrder: 4
  },
  {
    id: 5,
    title: "Drying & Dehumidification System",
    slug: "integrated-plastics",
    shortDescription: "Advanced systems for optimal material drying and moisture control.",
    description: "Our drying and dehumidification systems ensure proper moisture removal from plastic materials before processing. These systems are designed for energy efficiency and precise control of drying parameters to optimize material properties.",
    image: img5,
    isFeatured: true,
    displayOrder: 5
  },
  {
    id: 6,
    title: "Caps & Closures Mold",
    slug: "caps-mold",
    shortDescription: "Specialized molds for producing high-quality caps and closures.",
    description: "Our caps and closures molds are engineered for high-volume production with exceptional precision. These molds feature optimized cooling and ejection systems for maximum productivity while maintaining tight dimensional tolerances.",
    image: img6,
    isFeatured: true,
    displayOrder: 6
  },
  {
    id: 7,
    title: "Packaging Mold",
    slug: "packaging-mold",
    shortDescription: "Advanced molds for packaging solutions and container production.",
    description: "Our packaging molds are designed to create innovative packaging solutions with superior finish quality. These molds incorporate latest technology for efficient production of various packaging formats while ensuring dimensional accuracy and aesthetic appeal.",
    image: img7,
    isFeatured: true,
    displayOrder: 7
  },
  {
    id: 8,
    title: "Packaging-systems",
    slug: "packaging-systems",
    shortDescription: "High-quality liquid colorants and additives for plastic processing.",
    description: "Our liquid colorants and additives provide consistent color matching and enhanced material properties for plastic processing. These products are formulated for optimal dispersion and compatibility with various polymer systems to achieve desired performance characteristics.",
    image: img8,
    isFeatured: true,
    displayOrder: 8
  },
  {
  id: 9,
  title: "HTW",
  slug: "htw",
  shortDescription: "...",
  description: "...",
  image: img9,
  isFeatured: true,
  displayOrder: 9
},
{
  id: 10,
  title: "INTRAVIS",
  slug: "intravis",
  shortDescription: "...",
  description: "...",
  image: img11,
  isFeatured: true,
  displayOrder: 10
},
];

export default partnerData;